import { render, staticRenderFns } from "./ToeflOverall.vue?vue&type=template&id=eedf9b0c&scoped=true&"
import script from "./ToeflOverall.vue?vue&type=script&lang=js&"
export * from "./ToeflOverall.vue?vue&type=script&lang=js&"
import style0 from "./ToeflOverall.vue?vue&type=style&index=0&id=eedf9b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eedf9b0c",
  null
  
)

export default component.exports